import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import type { RoleName } from "../types";

export function ProtectedRoute({ roles }: { roles?: RoleName[] }) {
  const { user, loading, hasRole } = useAuth();

  if (loading) {
    return <p>Loading…</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.some((role) => hasRole(role))) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
